import React, { useState } from "react";
import ReceivableCard from './ReceivableCard'
import { ChevronLeft, ChevronRight, SlidersVertical } from 'lucide-react'
import PayableDetail from './PayableDetail'
import { Receivable } from '../../../api/types';
import Alert from '../../../components/Alert'
import { useIsMobile } from '../../../utils/hooks'

interface Props {
    handleSubPage: (page: string) => void
    data?: Receivable[];
}

const Receivables: React.FC<Props> = ({ handleSubPage, data }) => {
    const isMobile = useIsMobile()

    if (!data || data.length === 0) {
        return (
            <div className="w-full bg-white rounded-xl border p-5 flex flex-col flex-1">
                <div className="flex items-center mb-7 gap-4">
                    <button onClick={() => handleSubPage("dashboard")}>
                        <ChevronLeft />
                    </button>
                    <h2 className="font-semibold">
                        Receivables
                    </h2>
                </div>
                <div className="flex-1 flex items-center justify-center my-16">
                    <Alert label={"No data available"} subtitle={""} />
                </div>
            </div>
        )
    }

    return (
        <div className="flex-1 m-5">

            <div className="flex items-center mb-7 gap-4">
                <button onClick={() => handleSubPage("dashboard")}>
                    <ChevronLeft />
                </button>
                <h2 className="font-semibold">
                    Receivables
                </h2>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <div className="min-w-[600px]">
                    {/* Headers */}
                    <div className="table-header grid-cols-[2fr_1fr_1fr_1fr_1fr]">
                        <div>Customer</div>
                        <div>Status</div>
                        <div>Expected Amount</div>
                        <div>Account</div>
                        <div>Due in</div>
                        {/* <div className="flex justify-end"><SlidersVertical /></div> */}
                    </div>

                    {/* Receivable Rows */}
                    <div className="mt-5 flex flex-col gap-3">
                        {data.map((receivable, index) => (
                            <ReceivableCard data={receivable} />
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Receivables;
